import { apiGet } from '@/store/api';
import { useApplicationStore } from '@/store/applicationStore';

export async function getAgencySettings() {
  const data = await apiGet('helper/agencySettings/');
  if (data) {
    useApplicationStore().setAgencySettings(data);
  }
}
